"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _zh_TW = _interopRequireDefault(require("../../date-picker/locale/zh_TW"));
var _default = exports.default = _zh_TW.default;